import isQuote from '../../../helpers/isQuote'
import isRepost from '../../../helpers/isRepost'
import { Post } from '../../../../feedsSlice'
import { FeedProps } from '../../types'
import {
  getReplyFeedTitle,
  getReplyFeedSubtitle,
} from '../../../Header/helpers/getCustomTitle'

const getTimelineFeedProps = (
  feed: Post,
): Omit<FeedProps, 'renderUserWrapper'> => {
  switch (true) {
    case feed.originalPost &&
      feed.originalPost.path.length > 0 &&
      !isQuote(feed) &&
      isRepost(feed.originalPost):
      return {
        ...feed.originalPost,
        privacy: feed.privacy,
        stats: feed.originalPost.stats,
        headerTitle: getReplyFeedTitle(feed),
        headerSubtitle: getReplyFeedSubtitle(feed.originalPost),
      }
    case feed.path && feed.path.length > 0 && isRepost(feed):
      return {
        ...feed,
        privacy: 'PUBLIC', // reposts can be only public
      }
    case feed.originalPost &&
      !isQuote(feed) &&
      feed.repostOf === feed.originalPost.id:
      return {
        ...feed.originalPost,
        repostedBy: feed.repostedBy,
      }
    default:
      return feed
  }
}

export default getTimelineFeedProps
